/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Offline_HintInputs */



/**
* | output |
* | --- |
* | "Sending feedback needs a connection." |
*
* @param {Feedback_Offline_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_offline_hint = /** @type {((inputs?: Feedback_Offline_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Offline_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'envoi de commentaires nécessite une connexion.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El envío de comentarios requiere conexión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O envio de feedback requer conexão.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'invio del feedback richiede una connessione.")
	return /** @type {LocalizedString} */ ("Sending feedback needs a connection.")
});